/*
 * オリシェラ: スクロールで浮かび上がる演出と、奥行きのあるパララックス。
 *  data-ori-reveal            … 画面に入ったらふわっと表示("left" / "right" / "pop" で出方を変える)
 *  data-ori-delay="0.2"       … 表示の遅れ(秒)
 *  data-ori-parallax="0.15"   … スクロール量に対して上下にずらす割合(マイナスで逆方向)
 */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveal(root) {
    var targets = (root || document).querySelectorAll("[data-ori-reveal]:not(.is-inview)");
    targets.forEach(function (el) {
      var delay = el.getAttribute("data-ori-delay");
      if (delay) el.style.setProperty("--ori-delay", delay + "s");
    });
    if (reduce || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("is-inview"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-inview");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );
    targets.forEach(function (el) { io.observe(el); });
  }

  var parallaxItems = [];
  var ticking = false;

  function collectParallax() {
    parallaxItems = Array.prototype.map.call(document.querySelectorAll("[data-ori-parallax]"), function (el) {
      return { el: el, speed: parseFloat(el.getAttribute("data-ori-parallax")) || 0 };
    });
  }

  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var offset = (rect.top + rect.height / 2 - vh / 2) * item.speed;
      item.el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateParallax);
    }
  }

  function init() {
    document.documentElement.classList.add("js");
    initReveal();
    if (!reduce) {
      collectParallax();
      updateParallax();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // テーマエディタでセクションを追加・変更したとき
  document.addEventListener("shopify:section:load", function (e) {
    initReveal(e.target);
    collectParallax();
    updateParallax();
  });
})();
